import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import TopSection from './components/TopSection';
import CompanySection from './components/CompanySection';
import SupportOrgSection from './components/SupportOrgSection';
import PricingSection from './components/PricingSection';
import OfficeSection from './components/OfficeSection';
import ContactSection from './components/ContactSection';
import Navigation from './components/Navigation';

const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation isScrolled={isScrolled} scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <TopSection />
      <CompanySection />
      <SupportOrgSection />
      <PricingSection />
      <OfficeSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;